import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Alertas } from './pages/Alertas';
import { Ficha } from './pages/Ficha';
import { Team } from './pages/Team';
import { Analitica } from './pages/Analitica';
import { Config } from './pages/Config';
import { Marketing } from './pages/Marketing';
import { Admin } from './pages/Admin';
import { FormulariosWeb } from './pages/FormulariosWeb';
import { Comisiones } from './pages/Comisiones';
import { AppPacientes } from './pages/AppPacientes';
import { MiCuenta } from './pages/MiCuenta';
import { DialogoHost } from './components/Dialogo';
import { primeraRuta, seccionesEfectivas } from './lib/permisos';

// Quien no abre el Resumen (marketing, por default) entra a la primera sección que sí abre (Administración → Permisos).
function Home() {
  const { user } = useAuth();
  const secciones = seccionesEfectivas(user);
  if (!secciones.includes('resumen')) return <Navigate to={primeraRuta(secciones)} replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/alertas" element={<ProtectedRoute seccion="alertas"><Alertas /></ProtectedRoute>} />
          {/* "Mi día" (0.40.0) se volvió Alertas: el equipo da seguimiento en Halory. Ligas viejas no truenan. */}
          <Route path="/mi-dia" element={<Navigate to="/alertas" replace />} />
          <Route path="/paciente/:id" element={<ProtectedRoute seccion="fichas"><Ficha /></ProtectedRoute>} />
          <Route path="/equipo" element={<ProtectedRoute seccion="equipo"><Team /></ProtectedRoute>} />
          <Route path="/analitica" element={<ProtectedRoute seccion="analitica"><Analitica /></ProtectedRoute>} />
          <Route path="/marketing" element={<ProtectedRoute seccion={['marketing', 'galeria']}><Marketing /></ProtectedRoute>} />
          {/* La galería vive DENTRO de Marketing como pestaña; el path viejo redirige. */}
          <Route path="/galeria" element={<Navigate to="/marketing" replace />} />
          <Route path="/admin" element={<ProtectedRoute seccion="admin"><Admin /></ProtectedRoute>} />
          <Route path="/formularios" element={<ProtectedRoute seccion="formularios"><FormulariosWeb /></ProtectedRoute>} />
          <Route path="/config" element={<ProtectedRoute seccion="reglas"><Config /></ProtectedRoute>} />
          {/* Quien no es admin ve SUS comisiones (el servidor filtra por su sesión). */}
          <Route path="/comisiones" element={<ProtectedRoute seccion="comisiones"><Comisiones /></ProtectedRoute>} />
          <Route path="/app-pacientes" element={<ProtectedRoute seccion="app_pacientes"><AppPacientes /></ProtectedRoute>} />
          <Route path="/mi-cuenta" element={<ProtectedRoute><MiCuenta /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      {/* Los diálogos de la app (confirmar / avisar / pedirTexto): uno solo para todas las pantallas. */}
      <DialogoHost />
    </AuthProvider>
  );
}
